import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Galatea Solutions · Empowering Your Business</p>
        <h1>Transform Your Business with Expert IT Solutions</h1>
        <p className="lede">
          At Galatea Solutions, we specialize in providing tailored IT solutions and strategic business consulting for small to medium-sized enterprises. Let us help you navigate the complexities of technology and drive your business forward.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Streamlined IT Solutions</h2>
          <p>
            Our team delivers customized IT solutions that enhance efficiency and productivity, allowing you to focus on what you do best—running your business.
          </p>
        </article>
        <article>
          <h2>Strategic Business Consulting</h2>
          <p>
            We provide expert insights and strategies tailored to your unique business needs, helping you to achieve sustainable growth and success.
          </p>
        </article>
        <article>
          <h2>Ongoing Support and Partnership</h2>
          <p>
            With Galatea Solutions, you gain a trusted partner dedicated to your success, offering ongoing support and guidance every step of the way.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;